// Given a list of Cloudflare Image UUIDs, paired with their entity reference (special_id, comedian_id, etc),
// retrieve the Image URLs. Returns a dictionary of objects where the key is the entity_id (special_id, comedian_id)
// and its value is an object of the CDN Image Url and the Cloudflare UUID.

import { getCDNImageURL } from "./getCDNImageURL";

// Fallback to Punchup logo if a UUID is not found.
export const getCDNImageURLMap = async (
  imageEntity: { entityId: string; imageId: string }[]
): Promise<{
  [entityId: string]: {
    imageId: string;
    imageUrl: string;
  };
}> => {
  const imageMapDict: Record<
    string,
    {
      imageId: string;
      imageUrl: string;
    }
  > = {};

  await Promise.all(
    imageEntity.map(async (image) => {
      const { imageId, entityId } = image;
      // Punchup logo as default - even though we can expect these comedians to always have an image
      const fallbackImgUrl =
        "https://imagedelivery.net/7Ze32-hXUdrEDVtqvlbDMQ/dc9b5063-beaf-4709-e04b-eca128e74c00/public";
      let imageUrl;
      if (imageId) {
        try {
          imageUrl = getCDNImageURL(imageId);
        } catch {
          imageUrl = fallbackImgUrl;
          console.error("failed to fetch image from CDN");
        }
      } else {
        imageUrl = fallbackImgUrl;
      }
      imageMapDict[entityId] = {
        imageId: imageId,
        imageUrl: imageUrl,
      };
    })
  );
  return imageMapDict;
};
